import i18n  from '@/lang';

export default [
  {
    path: '/casestudy',
    name: '案例学习',
    component: () => import(/* webpackChunkName: "CaseStudy" */ '../views/CaseStudy/index.vue')
  },
]